import { component } from 'picoapp';

export default component(async (node) => {
  const delay = parseInt(node.dataset.delay, 10);
  const uspSlides = node.querySelectorAll('[data-current]');
  let index = 1;

  if (window.innerWidth < 768) {
    setInterval(() => {
      uspSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('data-current', 'false');
        if (index === slideIndex) {
          slide.setAttribute('data-current', 'true');
        }
      });

      if (index >= uspSlides.length - 1) {
        index = 0;
      } else {
        index += 1;
      }
    }, delay);
  }
});
